module.exports = __webpack_public_path__ + "assets/5f2cb390a6d39344d75dc64c6afc9e6f.mp3";